import { writable, get } from 'svelte/store';

import { wlc } from '@/config';


const _default = {
	card: {
		selected: [],
		available: [],
	},
	firm: {
		selected: [],
		available: [],
	},
	_update: true,
};


const { subscribe, set, update } = writable(Object.assign({}, _default));


export const filters = {
	subscribe,

	/* pull */
	pull: prop =>
		prop ? get(filters)[prop] : get(filters),

	/* push */
	push: value =>
		update(self => Object.assign(self, value)),

	/* pullSelected */
	pullSelected: prop => {
		const result = {};
		const data = get(filters);
		if (prop) {
			result[prop] = data[prop].selected;
		}
		else {
			for (const key in _default)
				if (key != '_update')
					result[key] = data[key].selected;
		}
		return result;
	},


	/* addAvailable */
	addAvailable: (prop, id) =>
		update(self => {
			if (self[prop].available.indexOf(id) == -1)
				self[prop].available.push(id);
			return self;
		}),

		
	/* addSelected */
	addSelected: (prop, id) =>
		update(self => {
			if (self[prop].available.indexOf(id) > -1)
				if (self[prop].selected.indexOf(id) == -1)
					self[prop].selected.push(id);
			return self;
		}),


	/* removeSelected */
	removeSelected: (prop, id) =>
		update(self => {
			const i = self[prop].selected.indexOf(id);
			if (i > -1)
				self[prop].selected.splice(i, 1);
			return self;
		}),


	/* pushSelected */
	pushSelected: (prop, data) =>
		update(self => {
			const temp = [];
			data.forEach(
				id => {
					if (self[prop].available.indexOf(id) > -1)
						temp.push(id);
				}
			);
			self[prop].selected = temp;
			return self;
		}),


	/* drop */
	drop: data =>
		update(self => {
			let i;
			i = self.card.available.indexOf(data.card_id);
			if (i > -1)
				self.card.available.splice(i, 1);
			i = self.card.selected.indexOf(data.card_id);
			if (i > -1)
				self.card.selected.splice(i, 1);
			i = self.firm.available.indexOf(data.card_id);
			if (i > -1)
				self.firm.available.splice(i, 1);
			i = self.firm.selected.indexOf(data.card_id);
			if (i > -1)
				self.firm.selected.splice(i, 1);
			return self;
		}),


	/* pushAvailable */
	pushAvailable: (prop, data) =>
		update(self => {
			if (prop) {
				self[prop].available = data;
				self[prop].selected = self[prop].selected.filter(item => data.indexOf(item) > -1);
				if (!self[prop].selected.length) {
					self[prop].selected = [ ...data ];
				}
			}
			else {
				for (const key in data) {
					self[key].available = data[key];
					self[key].selected = self[key].selected.filter(item => data[key].indexOf(item) > -1);
					if (!self[key].selected.length) {
						self[key].selected = [ ...data[key] ];
					}
				}
			}
			return self;
		}),
};
